var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.collection
    ? _c("div", { staticClass: "collection-grid--wrapper" }, [
        _vm.explodedProducts
          ? _c(
              "div",
              { staticClass: "collection-grid" },
              [
                _vm.collection
                  ? _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [
                        _c(
                          "div",
                          { staticClass: "row", class: _vm.gridClasses },
                          _vm._l(_vm.explodedProducts, function (item) {
                            return _c(
                              "div",
                              { key: item.title, staticClass: "column" },
                              [
                                _vm.useSubTiles
                                  ? _c("product-subscription-tile", {
                                      attrs: { product: item },
                                    })
                                  : _c("product-tile", {
                                      attrs: {
                                        product: item,
                                        bs_color: _vm.bs_color,
                                        np_color: _vm.np_color,
                                        nr_color: _vm.nr_color,
                                        so_color: _vm.so_color,
                                        le_color: _vm.le_color,
                                      },
                                    }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }